import { connect } from 'react-redux'

import EmploymentContainer from 'app/profile/renter/employment/employment_form_container'
import { fetchApplication } from 'app/sm/apply/apply_actions'
import {
  addEmployer,
  fetchEmployer,
  removeEmployer,
  updateEmployer,
} from 'app/sm/employment/actions'

const mapStateToProps = ({ Employment, Shared, apply }) => ({
  employer: Employment.employer,
  backUrl: Shared.backUrl,
  property: apply.property,
  isQLDForm22: apply.isQLDForm22,
})

const mapDispatchToProps = (dispatch) => ({
  addEmployer: (payload, success, fail) =>
    dispatch(addEmployer(payload, success, fail)),
  fetchEmployer: (id) => dispatch(fetchEmployer(id)),
  updateEmployer: (payload, id, success, fail) =>
    dispatch(updateEmployer(payload, id, success, fail)),
  removeEmployer: (id, propertyGUID, success, fail) =>
    dispatch(removeEmployer(id, propertyGUID, true, success, fail)),
  fetchApplication: (applicationId) =>
    dispatch(fetchApplication(applicationId)),
  ping: () => console.log('ping'),
})

export default connect(mapStateToProps, mapDispatchToProps)(EmploymentContainer)
